import React from 'react';

// Estilos globales (caja_status_2…) que todavía usan otras vistas
import "./Solicitud.css"

import DetalleSolicitud from '../../Compartidas/DetalleSolicitud';

import inscripcionesDataHelper from '../../../Helpers/InscripcionData';
import { LICENCIATURAS_INSCRIPCION, etiquetaLicenciatura } from '../../../Helpers/solicitudes';

// periodo se guarda como índice (1, 2 o 3)
const PERIODOS = ['', 'Enero – Abril', 'Mayo – Agosto', 'Septiembre – Diciembre'];

const fechaLarga = fecha => (fecha ? new Date(fecha).toLocaleDateString('es-MX', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'America/Mexico_City' }) : '');
const siNo = (tiene, detalle) => (tiene ? detalle || 'Sí' : 'No');

const SECCIONES = [
    {
        titulo: 'Alumno',
        campos: [
            { etiqueta: 'Licenciatura', valor: s => etiquetaLicenciatura(LICENCIATURAS_INSCRIPCION, s.licenciatura) },
            { etiqueta: 'Periodo escolar', valor: s => PERIODOS[s.periodo] },
            { etiqueta: 'Fecha de nacimiento', valor: s => fechaLarga(s.fechaNacimiento) },
            { etiqueta: 'Edad', valor: s => s.edad },
            { etiqueta: 'Grupo sanguíneo', valor: s => s.tipoSangre },
            { etiqueta: '¿Cómo nos encontró?', valor: s => s.medioEncontrado }
        ]
    },
    {
        titulo: 'Contacto',
        campos: [
            { etiqueta: 'Celular', valor: s => s.celular, tipo: 'telefono' },
            { etiqueta: 'Correo', valor: s => s.email, tipo: 'correo' }
        ]
    },
    {
        titulo: 'Domicilio',
        campos: [
            { etiqueta: 'Calle y número', valor: s => s.domicilio },
            { etiqueta: 'Colonia', valor: s => s.colonia },
            { etiqueta: 'Código postal', valor: s => s.codigoPostal },
            { etiqueta: 'Ciudad', valor: s => s.ciudad },
            { etiqueta: 'Estado', valor: s => s.estado },
            { etiqueta: 'País', valor: s => s.pais }
        ]
    },
    {
        titulo: 'Escuela de procedencia',
        campos: [
            { etiqueta: 'Escuela', valor: s => s.bachiller },
            { etiqueta: 'Generación', valor: s => s.generacion },
            { etiqueta: 'Ciudad de la escuela', valor: s => s.ciudadBachiller }
        ]
    },
    {
        titulo: 'Familia y emergencias',
        campos: [
            { etiqueta: 'Contacto de emergencia', valor: s => s.nombreEmergencia },
            { etiqueta: 'Teléfono de emergencia', valor: s => s.telefonoEmergencia, tipo: 'telefono' },
            { etiqueta: 'Madre', valor: s => s.nombreMadre },
            { etiqueta: 'Teléfono de la madre', valor: s => s.telefonoMadre, tipo: 'telefono' },
            { etiqueta: 'Padre', valor: s => s.nombrePadre },
            { etiqueta: 'Teléfono del padre', valor: s => s.telefonoPadre, tipo: 'telefono' }
        ]
    },
    {
        titulo: 'Salud y pago',
        campos: [
            { etiqueta: 'Condición especial', valor: s => siNo(Boolean(s.condicionEspecial), s.condicionEspecial) },
            { etiqueta: 'Enfermedad crónica', valor: s => siNo(s.enfermedad, s.enfermedadEspecificacion) },
            { etiqueta: '¿Cómo liquida el cuatrimestre?', valor: s => s.pago }
        ]
    }
];

const Solicitud = () => (
    <DetalleSolicitud
        helper={inscripcionesDataHelper}
        etiqueta='Solicitud de inscripción'
        licenciaturas={LICENCIATURAS_INSCRIPCION}
        secciones={SECCIONES}
        rutaActivas='/solicitud-inscripciones'
        rutaArchivo='/archivos-inscripciones'
    />
);

export default Solicitud;
